<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
        <v-card elevation="4">
            <v-card-title class="text-subtitle-1">
                <v-icon small class="pr-2" >mdi-tag-outline</v-icon>
                Adicionar Cuidados de Terceiros
            </v-card-title>
            <v-divider />
            <v-card-text>
                <p class="ma-2 text-sm-body-2">
                    <v-chip-group 
                        column 
                        multiple>
                        <v-chip
                            label
                            outlined
                            v-for="fc in listFormasCuidado" :key="fc.FormaCuidadoId"
                            @click="addThirdpartyCare(fc.FormaCuidadoId, fc.DescricaoForma)">
                        {{ fc.DescricaoForma }}
                        </v-chip>
                    </v-chip-group>
                    
                </p>
             </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer/>
                <v-btn
                    elevation="0"
                    color="secondary"
                    small
                    outlined
                    rounded 
                    @click="close">
                    <v-icon left>mdi-close</v-icon>
                Fechar
                </v-btn>
            </v-card-actions>
            <snackbar
                :text="snackbarMessage"
                :color="snackbarColor"
            />
        </v-card>
    </v-dialog>
</template>
<script>
import snackbarMixin from "@/mixins/snackbar.mixin";
import { mapGetters } from 'vuex';

export default {
    mixins: [snackbarMixin],
    props:{
        dialog:{
            default:false
        }
    },
    mounted() {},
    data(){
        return {
            listThirdpartyCareSelected:[]
        }
    },
    methods: {
        close(){
            this.$emit('update:dialog', false)
        },
        addThirdpartyCare(id, text){
            let tagFind = this.listThirdpartyCareSelected.map(e=>e.FormaCuidadoId).indexOf(id);

            if(tagFind == -1) {
                 this.listThirdpartyCareSelected.push({FormaCuidadoId:id, DescricaoForma:text});
             } else {
                 this.showSnackbar('Item já adicionado!', 'error');
             }

        },        
        loadThirdpartyCareRequest(item){
            //recebe os itens vindo da tela origem e atribui seu valor à variavel
            this.listThirdpartyCareSelected = item;
        },
        clear(){
        }
    },
    computed: {
        ...mapGetters('lists',['listFormasCuidado']),
    }

}
</script>
<style scoped>

</style>